<div class="text-center title-block">
  <h1 class="title">{{ title }}</h1>
  <p class="subtitle">{{ subtitle }}</p>
</div>